import { Controller } from "@hotwired/stimulus"
import "toastify-js/src/toastify.css"
import Toastify from 'toastify-js'
// Connects to data-controller="notify"
export default class extends Controller {
  static values = { mensager: String, type: String }
  connect() {
    Toastify({
      text: this.mensagerValue,
      duration: 5000,
      newWindow: true,
      close: true,
      gravity: "top", // `top` or `bottom`
      position: "center", // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      style: {
        background: this.typeValue,
      },
      onClick: function () { } // Callback after click
    }).showToast();
  }
}
